import {
    SYSTEM_LOCATION_CHANGED, SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE
} from '../constants/actionconstants';

export function locationChanged(location) {
    return (dispatch) => {
        dispatch({
            type: SYSTEM_LOCATION_CHANGED,
            payload: {
                location: location
            }
        });
    }
}

export function updateImageCacheBreakerValue() {
    return (dispatch) => {
        dispatch({
            type: SYSTEM_UPDATE_IMAGE_CACHE_BREAKER_VALUE,
            payload: {
                value: new Date().getTime()
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/client/src/actions/system.js